<template>
  <div id="listadocontroladoresregistrados">
    <div v-if="!items.length">
      <div class="ui icon warning message">
        <i class="inbox icon"></i>
        <div class="content">
          <div class="header">
            {{ $t("components.registeredTerminals.No_hay_dispositivos") }}
          </div>
          <p>{{ $t("components.registeredTerminals.Busca_con_boton_registrar") }}</p>
        </div>
      </div>
      <router-link class="item" to="/newTerminal">
        <div class="ui left floated small olive labeled icon button">
          <i class="plus icon"></i> {{$t("components.registeredTerminals.Registrar_nuevo")}}
        </div>
      </router-link>
    </div>

    <table v-if="items.length" class="ui compact celled definition table selectable sortable">
      <thead class="full-width">
        <tr>
          <th class="wide" :class="{ five: isAdmin, eight: !isAdmin }">{{ $t("components.registeredTerminals.Dispositivo") }}</th>
          <th class="wide center aligned no-sort" :class="{ three: isAdmin, five: !isAdmin }">{{ $t("components.registeredTerminals.Estado") }}</th>
          <th class="wide center aligned no-sort" :class="{ seven: isAdmin, three: !isAdmin }">{{ $t("components.registeredTerminals.Teleoperacion") }}</th>
          <th class="one wide no-sort" v-if="isAdmin"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="c in items" v-bind:key="c._id">
          <td>
            <div class="ui accordion">
              <div class="title" style="font-size: 16px;">
                 {{ c.description }}
              </div>
              <div class="content">
                <p class="transition visible" style="display: block !important;">
                  <ul style="font-weight: normal !important;">
                    <li><strong>{{$t("components.registeredTerminals.Número_de_serie")}}</strong>: {{ c.serial }}</li>
                    <li><strong>{{$t("components.registeredTerminals.Fecha_registro")}}</strong>: {{ moment(c.configuration.created).locale($i18n.locale).format("LLL") }}</li>
                    <li><strong>{{$t("components.registeredTerminals.Fecha_ultima_comunicacion")}}</strong>: {{ (new Date(c.lastCom).getTime() === 0) ? $t('components.common.Nunca') : moment(c.lastCom).locale($i18n.locale).format("LLL") }}</li>
                  </ul>
                </p>
              </div>
            </div>
          </td>
          <td class="center aligned">
            {{ getEstadoPuerta(c) }}
          </td>
          <td class="center aligned">
            <div class="ui icon button" data-inverted="" :data-tooltip="$t('components.registeredTerminals.Abrir_puerta')" data-position="bottom center" @click="sendOperation(c, 'abrirPuerta', $t('components.registeredTerminals.Esta_seguro_abrirPuerta'))"><i class="fas fa-door-open"></i></div>
            <div class="ui icon button" data-inverted="" :data-tooltip="$t('components.registeredTerminals.Cambiar_modo_puerta')" data-position="bottom center" @click="sendOperation(c, 'modoPuerta', $t('components.registeredTerminals.Esta_seguro_modoPuerta'))"><i class="fas fa-door-closed"></i><i class="fas fa-cog"></i></div>
            <div class="ui icon button" data-inverted="" :data-tooltip="$t('components.registeredTerminals.Reiniciar_terminal')" data-position="bottom center" @click="sendOperation(c, 'reiniciar', $t('components.registeredTerminals.Esta_seguro_reiniciar'))" v-if="isAdmin"><i class="microchip icon"></i><i class="sync alternate icon"></i></div>
            <div class="ui icon button" data-inverted="" :data-tooltip="$t('components.registeredTerminals.Enviar_fecha_hora')" data-position="bottom center" @click="sendOperation(c, 'establecerFecha', $t('components.registeredTerminals.Esta_seguro_establecerFecha'))" v-if="isAdmin"><i class="clock icon"></i></div>
            <div class="ui icon button" data-inverted="" :data-tooltip="$t('components.registeredTerminals.Descargar_usuarios')" data-position="bottom center" @click="sendOperation(c, 'descargarUsuarios', $t('components.registeredTerminals.Esta_seguro_descargarUsuarios'))" v-if="isAdmin"><i class="user icon"></i><i class="download icon"></i></div>
            <div class="ui icon button" data-inverted="" :data-tooltip="$t('components.registeredTerminals.Eliminar_usuarios')" data-position="bottom center" @click="sendOperation(c, 'borrarUsuarios', $t('components.registeredTerminals.Esta_seguro_borrarUsuarios'))" v-if="isAdmin"><i class="user icon"></i><i class="trash alternate icon"></i></div>
            <div class="ui icon button" data-inverted="" :data-tooltip="$t('components.registeredTerminals.Eliminar_eventos')" data-position="bottom center" @click="sendOperation(c, 'borrarEventos', $t('components.registeredTerminals.Esta_seguro_borrarEventos'))" v-if="isAdmin"><i class="copy icon"></i><i class="trash alternate icon"></i></div>
          </td>
          <td class="center aligned collapsing" v-if="isAdmin">
            <div class="ui icon buttons mini">
              <router-link class="item" :to="'/terminal/' + c._id">
                <button class="ui button">
                   <i class="pencil alternate icon"></i>
                </button>
              </router-link>
              <button class="ui red button" @click="unsubscribe(c._id)">
                <i class="times icon"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot class="full-width">
        <tr>
          <th colspan="4" v-if="isAdmin">
            <router-link class="item" to="/newTerminal">
              <div class="ui right floated small olive labeled icon button">
                <i class="plus icon"></i> {{$t("components.registeredTerminals.Registrar_nuevo")}}
              </div>
            </router-link>
          </th>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from '../utils/axios-general';
import Vue from 'vue';

export default {
  name: 'RegisteredTerminals',
  data: function () {
    return {
      items: [],
      moment: Vue.moment
    };
  },
  computed: {
    isAdmin: function() {
      return this.$store.state.user.role === 0;
    },
  },
  methods: {
    getEstadoPuerta: function (controller) {
      if (controller == null || controller.devices == null || controller.devices.length === 0) {
        return this.$i18n.t('components.registeredTerminals.Estado_2');
      }

      return this.$i18n.t('components.registeredTerminals.Estado_' + controller.devices[0].status.active.lastValue.v);
    },
    refresh: function () {
      axios.defaults.headers.common['x-access-token'] = this.$store.state.user.token;
      axios.get('/controllers').then(response => {
        if (response) {
          this.items = response.data.controllers;
        }
      }).catch((e, a, b, c) => {
        this.$swal.fire({
          type: 'error',
          title: this.$i18n.t('components.common.Error'),
          text: e
        });
      });
    },
    sendOperation: function (controller, operationName, messageConfirmation) {
      if (operationName === 'modoPuerta') {
        this.$swal.fire({
          title: messageConfirmation,
          text: this.$i18n.t('components.registeredTerminals.Selecciona_modo_puerta'),
          type: 'warning',
          input: 'select',
          inputOptions: new Map([
            [0, this.$i18n.t('components.registeredTerminals.Modo_puerta_cerrada')],
            [1, this.$i18n.t('components.registeredTerminals.Modo_puerta_privado')],
            [3, this.$i18n.t('components.registeredTerminals.Modo_puerta_abierta')],
            [4, this.$i18n.t('components.registeredTerminals.Modo_puerta_deshabilitado')]
          ]),
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$i18n.t('components.common.Si'),
          cancelButtonText: this.$i18n.t('components.common.No')
        }).then((result) => {
          if (result.value) {
            this.$swal.fire({
              title: this.$i18n.t('components.registeredTerminals.Enviando_operacion'),
              timer: 0,
              timerProgressBar: true,
              showConfirmButton: false,
              type: 'info',
              onBeforeOpen: () => {
                this.$swal.showLoading();
              }
            });
            axios.defaults.headers.common['x-access-token'] = this.$store.state.user.token;
            axios.put('/controller/' + controller._id + '/operation', { ope: operationName, modo: result.value }).then(response => {
              this.$swal.close();
              this.$swal.fire({
                title: this.$i18n.t('components.registeredTerminals.Operacion_enviada'),
                type: 'success'
              });
            }).catch(e => {
              this.$swal.close();
              this.$swal.fire({
                type: 'error',
                title: this.$i18n.t('components.common.Error'),
                text: ((e.response.data == null) || (e.response.data.length === 0)) ? this.$i18n.t('components.registeredTerminals.Imposible_enviar_operacion') : e.response.data
              });
            });
          }
        });
      } else {
        this.$swal.fire({
          title: messageConfirmation,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$i18n.t('components.common.Si'),
          cancelButtonText: this.$i18n.t('components.common.No')
        }).then((result) => {
          if (result.value) {
            this.$swal.fire({
              title: this.$i18n.t('components.registeredTerminals.Enviando_operacion'),
              timer: 0,
              timerProgressBar: true,
              showConfirmButton: false,
              type: 'info',
              onBeforeOpen: () => {
                this.$swal.showLoading();
              }
            });
            axios.defaults.headers.common['x-access-token'] = this.$store.state.user.token;
            axios.put('/controller/' + controller._id + '/operation', { ope: operationName }).then(response => {
              this.$swal.close();
              this.$swal.fire({
                title: this.$i18n.t('components.registeredTerminals.Operacion_enviada'),
                type: 'success'
              });
            }).catch(e => {
              this.$swal.close();
              this.$swal.fire({
                type: 'error',
                title: this.$i18n.t('components.common.Error'),
                text: ((e.response.data == null) || (e.response.data.length === 0)) ? this.$i18n.t('components.registeredTerminals.Imposible_enviar_operacion') : e.response.data
              });
            });
          }
        });
      }
    },
    unsubscribe: function (id) {
      this.$swal.fire({
        title: this.$i18n.t('components.registeredTerminals.Esta_seguro'),
        text: this.$i18n.t('components.registeredTerminals.Se_marca_como_borrado'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$i18n.t('components.common.Si'),
        cancelButtonText: this.$i18n.t('components.common.No')
      }).then((result) => {
        if (result.value) {
          axios.defaults.headers.common['x-access-token'] = this.$store.state.user.token;
          axios.delete('/controller/' + id).then(response => {
            this.$swal.fire(
              this.$i18n.t('components.registeredTerminals.Borrado'),
              this.$i18n.t('components.registeredTerminals.Se_ha_borrado'),
              'success'
            );
            setTimeout(() => {
              this.refresh();
            }, 500);
          }).catch(e => {
            this.$swal.fire({
              type: 'error',
              title: this.$i18n.t('components.common.Error'),
              text: e
            });
          });
        }
      });
    }
  },
  mounted: function () {
    this.refresh();

    setTimeout(() => {
      $('table')
        .DataTable({
          language: this.$i18n.t('components.datatable_language')
        })
        .on('draw', () => {
          $('#listadocontroladoresregistrados .accordion').accordion({
            selector: {
              trigger: '.title'
            }
          });
        });

      $('#listadocontroladoresregistrados .accordion')
        .accordion({
          selector: {
            trigger: '.title'
          }
        });
    }, 500);
  }
};
</script>
